import template from './searchWidget.html';

let component = {
	template,
	controller: function(
		$cordovaKeyboard,
		$filter,
		$ionicHistory,
		$ionicModal,
		$ionicPlatform,
		$q,
		$rootScope, 
		$scope,
		$state, 
		$stateParams,
		$timeout,
		_,
		Basket,
		Category,
		Compare,
		Customer,
		Filter,
		growl,
		Product,
		Search,
		Session, 
		User,
	) {
		"ngInject";

		var vm = this;
		var timeout;

		vm.picker = false;
		vm.show = false;
		vm.searching = false;
		vm.result = Session.get('quicksearch');
		vm.query = Filter.getActive('skey');
		vm.loading = false;
		vm.searchPage = $state.is('tab.search');

		if (vm.searchPage) {
			vm.category = 100000;
		} else {
			vm.category = 0;
		}

		User.categories().then(res => {
			vm.favorites = res;
		});

		Category.all().then(function(res) {
			vm.categories = _.flatMap(res, group => group.categories).map(category => {
				return {
					id: category.id,
					plural: category.lang[$rootScope.language].plural
				}
			});
		});

		vm.toProduct = function(uid) {
			Search.log({
				product_id: uid,
				query: vm.query,
				type: 'product',
			});
			$ionicHistory.nextViewOptions({
				disableBack: true
			});
			$state.go('tab.product', { uid: uid, ref:'quicksearch', query: vm.query });
		}

		vm.pickCategory = (id) => {
			vm.category = id;
			vm.picker = false;
		}

		vm.togglePicker = () => {
			vm.show = false;
			vm.picker = !vm.picker;
		}

		vm.toSearch = (categoryId) => {

			Search.log({
				category_id: categoryId,
				query: vm.query,
				type: 'category',
			});

			$timeout.cancel(timeout);
			vm.query = undefined;
			Filter.setAllActives({
				categories: categoryId ? [categoryId] : null
			});

			Filter.reload();
			
			$ionicHistory.nextViewOptions({
				historyRoot: true,
				disableBack: true
			});
			vm.show = false;
			$state.go('tab.search');
		}

		vm.clearSearch = () => {
			vm.query = undefined;
			$timeout(() => {
				document.getElementById('searchwidget').focus();
			}, 0);
			Filter.setActive('skey', undefined);
			Filter.change();
		}

		vm.close = () => {
			$timeout.cancel(timeout);
			vm.searching = false;
			vm.show = false;
			vm.picker = false;
		}

		vm.quickSearch = () => {
			vm.focusInput();
			vm.searching = false;
			if (vm.query !== undefined && vm.query.length > 0) {
				vm.searching = true;
				$timeout.cancel(timeout);
				timeout = $timeout(() => {
					Search.quick({
						query:vm.query,
						category:vm.category !== 0 && vm.category !== 100000 ? vm.category : null
					}).then(function(res) {
						Session.set('quicksearch', res);
						vm.result = res;
						vm.searching = false;
					});
				}, 1000);
			}
		}

		vm.buy = ($event, product) => {

			var addProduct = function(product) {
				vm.loading = true;
				Basket.add(product.id).then(() => {
					growl.success($filter('translate')('growl_basket_product_added'));
					return Product.get(product.id, {
						include: 'accessories,services'
					}).then(function(res) {
						if ((res.accessories && res.accessories.length > 0) || (res.services && res.services.length > 0)) {
							$scope.product = res;
							$scope.modal = $ionicModal.fromTemplate('<upsell modal="modal" product="product"></upsell>', {
								scope: $scope,
								animation: 'slide-in-up'
							});
							$scope.modal.show();
						}
					});
				}).catch(function(err) {
					console.log(err);
				}).finally(() => {
					vm.loading = false;
				});
			}

			$event.stopPropagation();
			if (!vm.loading) {
				vm.loading = true;
				if(!Customer.session()) {
					Customer.create().then(() => {
						growl.info($filter('translate')('growl_automatic_customer_session_created'));
						addProduct(product);
					});
				} else {
					addProduct(product);
				}
			}
		}

		vm.compare = ($event, product) => {
			$event.stopPropagation();
			Compare.add(product);
		}

		vm.focusInput = () => {
			vm.show = !(vm.searchPage && vm.category === 100000);
		}

		vm.search = () => {
			vm.show = false;
			var activeCategories = Filter.getActive('categories');
			var sameCategories = _.isEqual([vm.category], activeCategories);

			if (vm.searchPage && (vm.category === 100000 || (vm.category && sameCategories))) {
				Search.log({
					category_id: activeCategories,
					query: vm.query,
					type: 'submit',
				});
				Filter.setActive('skey', vm.query);
				Filter.change();
				$ionicPlatform.ready(() => {
					if (window.cordova) {
						$cordovaKeyboard.close();
					}
				});
			} else {
				Search.log({
					category_id: vm.category,
					query: vm.query,
					type: 'submit',
				});
				Filter.setAllActives({
					skey: vm.query,
					categories: vm.category ? [vm.category] : null
				});
				Filter.reload();

				$ionicHistory.nextViewOptions({
					historyRoot: true,
					disableBack: true
				});
				$state.go('tab.search');
			}
		}

		function filtersChanged() {
			vm.query = Filter.getActive('skey');
		}

		$scope.$on('filters:interface', e => {
			filtersChanged();
		});

		$scope.$on('filters:changed', e => {
			filtersChanged();
		});

		$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
			vm.show = false;
			vm.searchPage = $state.is('tab.search');

			if (vm.searchPage) {
				vm.category = 100000;
			} else {
				if (vm.category === 100000) {
					vm.category = 0;
				}
			}

			if (fromState.name === 'tab.search' && !Filter.getActive('skey')) {
				vm.query = undefined;
			}
		});
	}
}

export default component;


// WEBPACK FOOTER //
// ./app/components/searchWidget/searchWidget.component.js